const releaseTiming: KeyframeAnimationOptions = {
  duration: 200,
  easing: "ease",
};
const landingLayer = 20;
const passingLayer = 10;

function slideHome(node: HTMLElement, fromRect: DOMRect, homeRect: DOMRect, layer: number) {
  const offsetX = fromRect.left - homeRect.left;
  const offsetY = fromRect.top - homeRect.top;
  const startFrame: Keyframe = {
    transform: `translate(${offsetX}px, ${offsetY}px)`,
    zIndex: layer,
    backgroundColor: "white",
  };
  const endFrame: Keyframe = {
    transform: "translate(0, 0)",
    zIndex: layer,
    backgroundColor: "white",
  };
  node.animate([startFrame, endFrame], releaseTiming);
}

function measureRelease(node: HTMLElement) {
  const releasedRect = node.getBoundingClientRect();
  node.style.transform = "";
  const homeRect = node.getBoundingClientRect();
  return { releasedRect, homeRect };
}

export function animateSwapRelease(sourceNode: HTMLElement, targetNode: HTMLElement) {
  const source = measureRelease(sourceNode);
  const targetHomeRect = targetNode.getBoundingClientRect();
  slideHome(targetNode, source.releasedRect, targetHomeRect, landingLayer);
  slideHome(sourceNode, targetHomeRect, source.homeRect, passingLayer);
}

export function animateReturnRelease(sourceNode: HTMLElement) {
  const source = measureRelease(sourceNode);
  slideHome(sourceNode, source.releasedRect, source.homeRect, landingLayer);
}
